/**
 * WebSocket context types and React context object.
 * Separated from the Provider component for Vite Fast Refresh compatibility.
 */

import { createContext } from 'react'

export type ConnectionState = 'connecting' | 'connected' | 'disconnected' | 'error'

export interface WebSocketMessage<T = unknown> {
  type: string
  payload: T
  timestamp?: number
}

export interface WebSocketContextValue {
  /** Current connection state */
  connectionState: ConnectionState
  /** Whether the WebSocket is currently connected */
  isConnected: boolean
  /** Last received message */
  lastMessage: WebSocketMessage | null
  /** Send a message to the WebSocket server */
  send: <T>(type: string, payload: T) => void
  /** Close the current connection */
  close: () => void
  /** Force reconnect */
  reconnect: () => void
}

export const WebSocketContext = createContext<WebSocketContextValue | null>(null)
